export default __webpack_public_path__ + "static/media/search.6c7ba72d.svg";